import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TrustBand } from './TrustBand';
export function Hero() {
  return <section className="bg-[#0A0A0A]" data-id="element-116">
      <div className="max-w-6xl mx-auto px-6 pt-12 pb-0 md:pt-20" data-id="element-117">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-118">
          {/* Left — Product Image Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="order-2 lg:order-1" data-id="element-119">
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/4dWx1GL3wbZUnsHWfxQLBS/ChatGPT_Image_Feb_17,_2026,_02_15_56_PM.png" alt="CrownControl red light therapy cap with before and after results" className="w-full h-full object-contain" data-id="element-121" />
            </div>
          </motion.div>

          {/* Right — Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: 'easeOut'
        }} className="order-1 lg:order-2" data-id="element-122">
            <p className="text-[#C8A04A] text-xs md:text-sm font-medium tracking-[0.2em] uppercase mb-6 leading-relaxed" data-id="element-123">
              For men who refuse to shave it — but won't gamble their hormones
              to keep it.
            </p>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#F5F5F0] tracking-tight leading-[1.1] mb-6" data-id="element-124">
              Your Hair Isn't Dying.
              <br data-id="element-125" />
              <span className="text-[#C8A04A]" data-id="element-126">It's Being Starved.</span>
            </h1>

            <p className="text-lg text-[#9CA3AF] leading-relaxed mb-8 max-w-lg" data-id="element-127">
              Dermatology research shows why follicles go dormant – and why
              blocking DHT alone isn't enough.
            </p>

            <CTAButton data-id="element-128" />
          </motion.div>
        </div>
      </div>

      {/* Trust Band — full width */}
      <div className="mt-16" data-id="element-129">
        <TrustBand data-id="element-130" />
      </div>
    </section>;
}